import { Icon, useTranslation } from '@testsigma/atoms';
import React, { FC } from 'react';

const WEBINAR_URL =
  'https://testsigma.com/context-to-execution?utm_source=Product%20Hello%20bar&utm_medium=email&utm_campaign=AI%20Testing%20webinar%20series';

interface WebinarBannerProps {
  onClose: () => void;
}

const WebinarBanner: FC<WebinarBannerProps> = ({ onClose }) => {
  const { t } = useTranslation();

  return (
    <div className='w-full relative flex flex-row items-center justify-center'>
      <div className='flex items-center justify-center w-full'>
        <span className='text-md text-unique-600'>
          <span className='font-normal'>
            {t('announcement_banner.webinar_message')}
          </span>{' '}
          <a
            href={WEBINAR_URL}
            target='_blank'
            rel='noopener noreferrer'
            className='font-bold underline text-unique-600 hover:text-unique-800'
          >
            {t('announcement_banner.webinar_cta')}
          </a>
        </span>
        <Icon
          name='close'
          className='text-[24px] text-unique-600 items-center cursor-pointer flex-shrink-0 absolute right-0'
          onClick={onClose}
        />
      </div>
    </div>
  );
};

export default WebinarBanner;
